module.exports = __webpack_public_path__ + "static/media/banner.9da77404.png";